import BloomObserver from '../observer';
import FocusConnector from '../../focus/connector';
import { VISIBLE_FOCUSABLE } from '../../focus/const';

const $ = jQuery;
/**
 * Stores the original focus when optin shows
 * Restores the original focus when optin hides
 * Automatically shifts keyboard focus to the optin when it shows
 * For popups and flyins:
 *
 *  - contraints focus to popup focusables
 *  - the availability of popup announced to the screen reader
 */
export default class FixKeyboardIssueInPopups {
	flyinObserver = null;
	flyinConnector = null;
	popupObserver = null;
	popupConnector = null;
	originalFocusable = null;
	firstPopupFocusable = null;
	lastPopupFocusable = null;
	firstFlyinFocusable = null;
	lastFlyinFocusable = null;
	static SELECTOR = '.et_bloom_popup, .et_bloom_flyin';
	static POPUP_SELECTOR = '.et_bloom_popup';
	static FLYIN_SELECTOR = '.et_bloom_flyin';

	isPopup() {
		return jQuery(FixKeyboardIssueInPopups.POPUP_SELECTOR).length > 0;
	}

	isFlyin() {
		return jQuery(FixKeyboardIssueInPopups.FLYIN_SELECTOR).length > 0;
	}


	storeOriginalFocus(force = false) {
		if (force) {
			this.originalFocusable = null;
		}
		// Store it only once
		if (!this.originalFocusable) {
			this.originalFocusable = document.activeElement;
		}
	}

	restoreOriginalFocus() {
		if (this.originalFocusable) {
			this.originalFocusable.focus();
			this.originalFocusable = null;
		}
	}

	announcePopup() {
		// Find the header of opt-in
		const header = $(FixKeyboardIssueInPopups.POPUP_SELECTOR).find('h1,h2').get(0);
		// Provide the header
		if (!header.id) {
			header.id = 'bloom_popup_header';
		}
		// Provide aria attributes
		$(FixKeyboardIssueInPopups.POPUP_SELECTOR)
			.attr('aria-modal', 'true')
			.attr('role', 'dialog')
			.attr('aria-labelledby', header.id);
	}
	announceFlyin() {
		// Find the header of opt-in
		const header = $(FixKeyboardIssueInPopups.FLYIN_SELECTOR).find('h1,h2').get(0);
		// Provide the header
		if (!header.id) {
			header.id = 'bloom_flyin_header';
		}
		// Provide aria attributes
		$(FixKeyboardIssueInPopups.FLYIN_SELECTOR)
			.attr('aria-modal', 'true')
			.attr('role', 'dialog')
			.attr('aria-labelledby', header.id);
	}

	start() {
		// Check if bloom flyin presents on the page
		if (!$(FixKeyboardIssueInPopups.SELECTOR).length) {
			return;
		}
		// only one time, we need to update attributes of popup opt-in
		if (this.isPopup()) {
			this.announcePopup();
			this.popupObserver = new BloomObserver($(FixKeyboardIssueInPopups.POPUP_SELECTOR).get(0));
		}
		if (this.isFlyin()) {
			this.announceFlyin();
			this.flyinObserver = new BloomObserver($(FixKeyboardIssueInPopups.FLYIN_SELECTOR).get(0));
		}

		this.attachEventListeners();
	}

	/**
	 * Locates first and last focusables that belong only to popup opt-in
	 */
	locatePopupFocusablesForRedirection() {
		const focusableElements = $(FixKeyboardIssueInPopups.POPUP_SELECTOR).find(VISIBLE_FOCUSABLE);
		this.firstPopupFocusable = focusableElements.get(0);
		this.lastPopupFocusable = focusableElements.get(focusableElements.length - 1);
	}
	locateFlyinFocusablesForRedirection() {
		const focusableElements = $(FixKeyboardIssueInPopups.FLYIN_SELECTOR).find(VISIBLE_FOCUSABLE);
		this.firstFlyinFocusable = focusableElements.get(0);
		this.lastFlyinFocusable = focusableElements.get(focusableElements.length - 1);
	}

	/**
	 * Locates first focusable that belongs to flyin and popup opt-ins. Once located the element receives focus.
	 */
	focusFirstFocusable(force = false) {
		const focusableElements = $(FixKeyboardIssueInPopups.SELECTOR).find(VISIBLE_FOCUSABLE);
		const firstFocusable = focusableElements.get(0);
		if (firstFocusable) {
			this.storeOriginalFocus(force);
			firstFocusable.focus();
		}
	}

	attachEventListeners() {
		const self = this;
		if (this.popupObserver) {
			this.popupObserver.onShow(() => {
				self.locatePopupFocusablesForRedirection();
				self.popupConnector = new FocusConnector(self.lastPopupFocusable, self.firstPopupFocusable);
				self.popupConnector.link();
				// Popup should always store actual focusable
				self.focusFirstFocusable(true);
			});
			this.popupObserver.onClose(() => {
				self.popupConnector.unlink();
				self.restoreOriginalFocus();
			});
		}
		if (this.flyinObserver) {
			this.flyinObserver.onShow(() => {
				self.locateFlyinFocusablesForRedirection();
				self.flyinConnector = new FocusConnector(self.lastFlyinFocusable, self.firstFlyinFocusable);
				self.flyinConnector.link();
				self.focusFirstFocusable();
			});
			this.flyinObserver.onClose(() => {
				self.flyinConnector.unlink();
				self.restoreOriginalFocus();
			});
		}
	}
}



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/accessibility/bloom/controllers/fix-keyboard-issue-in-popups.js